import React from "react"
import { graphql } from "gatsby"
import Page from "../components/Page"
import MAndV from "../screens/AboutUs/MAndV"
import WhoWeAre from "../screens/AboutUs/WhoWeAre"
import OurHistory from "../screens/AboutUs/OurHistory"

import TheEB from "../screens/AboutUs/TheEB"
import OurProjects from "../screens/AboutUs/OurProjects"
import SEO from "../components/SEO"

const AboutUs: React.FC<{ data: Object }> = function (props) {
  const data = props.data
  //@ts-ignore
  const renderedData = data.allContentfulAboutUs.edges[0].node
  //@ts-ignore
  const EBData = data.allContentfulExecutiveBoard.nodes[0]
  const whoWeAreHeader = renderedData.whoWeAreHeader
  const whoWeAreDescription =
    renderedData.whoWeAreDescription.whoWeAreDescription
  const heroImageFluid = renderedData.heroImage.localFile.childImageSharp.fluid
  const mission = renderedData.mission.mission
  const vision = renderedData.vision.vision
  const heightsToday = renderedData.heightsToday
  const heightsTodayDate = renderedData.heightsTodayDate
  const heightsTodayContentColumnA = renderedData.heightsTodayContentColumnA
  const heightsTodayContentColumnB = renderedData.heightsTodayContentColumnB

  const yearsHence = renderedData.yearsHence
  const yearsHenceDate = renderedData.yearsHenceDate
  const yearsHenceContentColumnA = renderedData.yearsHenceContentColumnA
  const yearsHenceContentColumnB = renderedData.yearsHenceContentColumnB

  const poetizationAndFilipinization = renderedData.poetizationAndFilipinization
  const poetizationAndFilipinizationDate =
    renderedData.poetizationAndFilipinizationDate
  const poetizationAndFilipinizationContentColumnA =
    renderedData.poetizationAndFilipinizationContentColumnA
  const poetizationAndFilipinizationContentColumnB =
    renderedData.poetizationAndFilipinizationContentColumnB

  const aPoliticalShift = renderedData.aPoliticalShift
  const aPoliticalShiftDate = renderedData.aPoliticalShiftDate
  const aPoliticalShiftContentColumnA =
    renderedData.aPoliticalShiftContentColumnA
  const aPoliticalShiftContentColumnB =
    renderedData.aPoliticalShiftContentColumnB

  const beforeHeights = renderedData.beforeHeights
  const beforeHeightsDate = renderedData.beforeHeightsDate
  const beforeHeightsContentColumnA = renderedData.beforeHeightsContentColumnA
  const beforeHeightsContentColumnB = renderedData.beforeHeightsContentColumnB

  const editorInChiefName = EBData.editorInChiefName
  const editorInChiefCourse = EBData.editorInChiefCourse
  const associateEditorName = EBData.associateEditorName
  const associateEditorCourse = EBData.associateEditorCourse
  const managingEditorForFinanceName = EBData.managingEditorForFinanceName
  const managingEditorForFinanceCourse = EBData.managingEditorForFinanceCourse
  const managingDirectorForExternalAffairsName =
    EBData.managingDirectorForExternalAffairsName
  const managingDirectorForExternalAffairsCourse =
    EBData.managingDirectorForExternalAffairsCourse
  const managingEditorForInternalAffairsName =
    EBData.managingEditorForInternalAffairsName
  const managingEditorForInternalAffairsCourse =
    EBData.managingEditorForInternalAffairsCourse
  const artEditorName = EBData.artEditorName
  const artEditorCourse = EBData.artEditorCourse
  const associateArtEditorName = EBData.associateArtEditorName
  const associateArtEditorCourse = EBData.associateArtEditorCourse
  const englishEditorName = EBData.englishEditorName
  const englishEditorCourse = EBData.englishEditorCourse
  const associateEnglishEditorName = EBData.associateEnglishEditorName
  const associateEnglishEditorCourse = EBData.associateEnglishEditorCourse
  const heightsOnlineEditorName = EBData.heightsOnlineEditorName
  const heightsOnlineEditorCourse = EBData.heightsOnlineEditorCourse
  const heightsAssociateOnlineEditorName =
    EBData.heightsAssociateOnlineEditorName
  const heightsAssociateOnlineEditorCourse =
    EBData.heightsAssociateOnlineEditorCourse
  const designEditorName = EBData.designEditorName
  const designEditorCourse = EBData.designEditorCourse
  const associateDesignEditorName = EBData.associateDesignEditorName
  const associateDesignEditorCourse = EBData.associateDesignEditorCourse
  const patnugotNgBagwisangFilipinoName = EBData.patnugotNgBagwisangFilipinoName
  const patnugotNgBagwisangFilipinoCourse =
    EBData.patnugotNgBagwisangFilipinoCourse
  const productionManagerName = EBData.productionManagerName
  const productionManagerCourse = EBData.productionManagerCourse
  const katuwangNaPatnugotNgBagwisangFilipinoName =
    EBData.katuwangNaPatnugotNgBagwisangFilipinoName
  const katuwangNaPatnugotNgBagwisangFilipinoCourse =
    EBData.katuwangNaPatnugotNgBagwisangFilipinoCourse
  const associateProductionManagerName = EBData.associateProductionManagerName
  const associateProductionManagerCourse =
    EBData.associateProductionManagerCourse

  return (
    <Page contactUsVisibility="show">
      <SEO title="About Us" />
      <WhoWeAre
        whoWeAreHeader={whoWeAreHeader}
        whoWeAreDescription={whoWeAreDescription}
        heroImageFluid={heroImageFluid}
      />
      <MAndV mission={mission} vision={vision} />
      <OurHistory
        heightsToday={heightsToday}
        heightsTodayDate={heightsTodayDate}
        heightsTodayContentColumnA={heightsTodayContentColumnA}
        heightsTodayContentColumnB={heightsTodayContentColumnB}
        yearsHence={yearsHence}
        yearsHenceDate={yearsHenceDate}
        yearsHenceContentColumnA={yearsHenceContentColumnA}
        yearsHenceContentColumnB={yearsHenceContentColumnB}
        poetizationAndFilipinization={poetizationAndFilipinization}
        poetizationAndFilipinizationDate={poetizationAndFilipinizationDate}
        poetizationAndFilipinizationContentColumnA={
          poetizationAndFilipinizationContentColumnA
        }
        poetizationAndFilipinizationContentColumnB={
          poetizationAndFilipinizationContentColumnB
        }
        aPoliticalShift={aPoliticalShift}
        aPoliticalShiftDate={aPoliticalShiftDate}
        aPoliticalShiftContentColumnA={aPoliticalShiftContentColumnA}
        aPoliticalShiftContentColumnB={aPoliticalShiftContentColumnB}
        beforeHeights={beforeHeights}
        beforeHeightsDate={beforeHeightsDate}
        beforeHeightsContentColumnA={beforeHeightsContentColumnA}
        beforeHeightsContentColumnB={beforeHeightsContentColumnB}
      />
      <TheEB
        editorInChiefName={editorInChiefName}
        editorInChiefCourse={editorInChiefCourse}
        associateEditorName={associateEditorName}
        associateEditorCourse={associateEditorCourse}
        managingEditorForFinanceName={managingEditorForFinanceName}
        managingEditorForFinanceCourse={managingEditorForFinanceCourse}
        managingDirectorForExternalAffairsName={
          managingDirectorForExternalAffairsName
        }
        managingDirectorForExternalAffairsCourse={
          managingDirectorForExternalAffairsCourse
        }
        managingEditorForInternalAffairsName={
          managingEditorForInternalAffairsName
        }
        managingEditorForInternalAffairsCourse={
          managingEditorForInternalAffairsCourse
        }
        artEditorName={artEditorName}
        artEditorCourse={artEditorCourse}
        associateArtEditorName={associateArtEditorName}
        associateArtEditorCourse={associateArtEditorCourse}
        englishEditorName={englishEditorName}
        englishEditorCourse={englishEditorCourse}
        associateEnglishEditorName={associateEnglishEditorName}
        associateEnglishEditorCourse={associateEnglishEditorCourse}
        heightsOnlineEditorName={heightsOnlineEditorName}
        heightsOnlineEditorCourse={heightsOnlineEditorCourse}
        heightsAssociateOnlineEditorName={heightsAssociateOnlineEditorName}
        heightsAssociateOnlineEditorCourse={heightsAssociateOnlineEditorCourse}
        designEditorName={designEditorName}
        designEditorCourse={designEditorCourse}
        associateDesignEditorName={associateDesignEditorName}
        associateDesignEditorCourse={associateDesignEditorCourse}
        patnugotNgBagwisangFilipinoName={patnugotNgBagwisangFilipinoName}
        patnugotNgBagwisangFilipinoCourse={patnugotNgBagwisangFilipinoCourse}
        productionManagerName={productionManagerName}
        productionManagerCourse={productionManagerCourse}
        katuwangNaPatnugotNgBagwisangFilipinoName={
          katuwangNaPatnugotNgBagwisangFilipinoName
        }
        katuwangNaPatnugotNgBagwisangFilipinoCourse={
          katuwangNaPatnugotNgBagwisangFilipinoCourse
        }
        associateProductionManagerName={associateProductionManagerName}
        associateProductionManagerCourse={associateProductionManagerCourse}
      />
      <OurProjects />
    </Page>
  )
}

export default AboutUs

export const query = graphql`
  query MyQuery {
    allContentfulAboutUs {
      edges {
        node {
          whoWeAreHeader
          whoWeAreDescription {
            whoWeAreDescription
          }
          mission {
            mission
          }
          vision {
            vision
          }
          heroImage {
            localFile {
              childImageSharp {
                fluid(maxWidth: 700) {
                  ...GatsbyImageSharpFluid_tracedSVG
                  ...GatsbyImageSharpFluidLimitPresentationSize
                }
              }
            }
          }
          heightsToday
          heightsTodayDate
          heightsTodayContentColumnB {
            raw
          }
          heightsTodayContentColumnA {
            raw
          }
          yearsHence
          yearsHenceDate
          yearsHenceContentColumnA {
            raw
          }
          yearsHenceContentColumnB {
            raw
          }
          poetizationAndFilipinization
          poetizationAndFilipinizationDate
          poetizationAndFilipinizationContentColumnA {
            raw
          }
          poetizationAndFilipinizationContentColumnB {
            raw
          }
          aPoliticalShift
          aPoliticalShiftDate
          aPoliticalShiftContentColumnA {
            raw
          }
          aPoliticalShiftContentColumnB {
            raw
          }
          beforeHeights
          beforeHeightsDate
          beforeHeightsContentColumnA {
            raw
          }
          beforeHeightsContentColumnB {
            raw
          }
        }
      }
    }
    allContentfulExecutiveBoard {
      nodes {
        editorInChiefName
        editorInChiefCourse
        associateEditorName
        associateEditorCourse
        managingEditorForFinanceName
        managingEditorForFinanceCourse
        managingDirectorForExternalAffairsName
        managingDirectorForExternalAffairsCourse
        managingEditorForInternalAffairsName
        managingEditorForInternalAffairsCourse
        artEditorName
        artEditorCourse
        associateArtEditorName
        associateArtEditorCourse
        englishEditorName
        englishEditorCourse
        associateEnglishEditorName
        associateEnglishEditorCourse
        heightsOnlineEditorName
        heightsOnlineEditorCourse
        heightsAssociateOnlineEditorName
        heightsAssociateOnlineEditorCourse
        designEditorName
        designEditorCourse
        associateDesignEditorName
        associateDesignEditorCourse
        patnugotNgBagwisangFilipinoName
        patnugotNgBagwisangFilipinoCourse
        productionManagerName
        productionManagerCourse
        katuwangNaPatnugotNgBagwisangFilipinoName
        katuwangNaPatnugotNgBagwisangFilipinoCourse
        associateProductionManagerName
        associateProductionManagerCourse
      }
    }
  }
`
